import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login'
import Members from '@/components/memberlist'
import Editmember from '@/components/edit-member'
import Editstore from '@/components/edit-store'
import Dashboard from '@/components/dashboard'
import Memberinfo from '@/components/member-info'
import Addmember from '@/components/add-member'
import Profile from '@/components/profile'
import Memberdashboard from '@/components/member-dashboard'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/members',
      name: 'memberlist',
      component: Members
    },
    {
      path: '/member_info/:id',
      name: 'member_info',
      component: Memberinfo
    },
    {
      path: '/edit_member/:eid',
      name: 'editmember',
      component: Editmember
    },
    {
      path: '/edit_store/:eid',
      name: 'editstore',
      component: Editstore
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/newmember',
      name: 'addmember',
      component: Addmember
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile
    },
    {
      path: '/member-dashboard/:mid',
      name: 'member-dashboard',
      component: Memberdashboard
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js